// libs
import React from 'react';

// components
import SizeGuide from 'shared/layouts/SizeGuide';
import { OverlaySheetContext } from 'shared/components/OverlaySheet';

// styles
import { OverlaySheet, Container } from './styles';

// constants
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet/constants';

function SizeGuideBottomSheet({
  onClose,
  onSizeSelect,
  selectedSize,
  isAddedToCart,
  addToCart,
  selectedSizeName,
  outOfStockSizes,
  stockRemainingMap,
}: {
  onClose: () => void;
  onSizeSelect?: (sizeName: string) => void;
  selectedSize?: ProductDetail.ISizeOption;
  isAddedToCart?: boolean;
  addToCart?: () => void;
  selectedSizeName?: string;
  outOfStockSizes?: string[];
  stockRemainingMap?: Record<string, number>;
}) {
  return (
    <OverlaySheet
      onHide={onClose}
      transitionFrom={SHEET_TRANSITION.BOTTOM}
      disableNav
      navKey="sizeGuideMobile"
      hideOnOverlayClick={true}
      allowScroll={false}
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <Container>
            <SizeGuide
              onClose={doHide}
              onSizeSelect={onSizeSelect}
              selectedSize={selectedSize}
              isAddedToCart={isAddedToCart}
              addToCart={addToCart}
              selectedSizeName={selectedSizeName}
              outOfStockSizes={outOfStockSizes}
              stockRemainingMap={stockRemainingMap}
            />
          </Container>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}

export default SizeGuideBottomSheet;
